module.exports = __webpack_public_path__ + "img/yx4-zh.5510fee6.jpg";